import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import { VideoItem, VideoPlayerState } from "./types";
import axios from "axios";
import { API_URL } from "config";

const initialState: VideoPlayerState = {
  video: undefined,
};

const videoPlayer = createSlice({
  name: "videoPlayerSlice",
  initialState,
  reducers: {
    setVideoPlayerData(state, action) {
      state.video = action.payload;
    },
  },
});
export const { setVideoPlayerData } = videoPlayer.actions;
export const selectVideoPlayerData = (state: RootState) =>
  state.videoPlayer.video;
export const getVideoData = () => async (dispatch: any) => {
  try {
    const res = await axios.get(`${API_URL}/video-info`);
    const activeOne = res.data.data.find((item: VideoItem) => item.is_active);
    dispatch(setVideoPlayerData(activeOne));
  } catch (error: any) {
    alert(error);
  }
};
export default videoPlayer.reducer;
